import { useTranslation } from "../../../../hooks/useTranslation";
import { FormatDate, FormatPrice, FormatUnit } from "../../../../utils/generalUtils";
import style from "./index.module.css";

const VehicleHeader = ({
  name,
  model,
  price,
  phone,
  date,
  maintenance,
  mileage,
  least_deposit,
  least_installment,
  has_discount = false,
  old_price = "",
  vehicleState,
  rent,
}: ComponentPropsType) => {
  const { locale } = useTranslation();

  return (
    <div className={`${style.header} row`}>
      <div className="col-md-7">
        <h2 className={style.header_title}>
          {name.split(" ").map((v, index, array) => (
            <span
              key={index}
              style={{
                display: "inline-block",
                unicodeBidi: "embed",
                marginRight: "0.25em",
              }}
            >
              {v}
            </span>
          ))}
        </h2>
        {model && <p className={style.header_note}>{model}</p>}
        {vehicleState === "new" &&
          (maintenance ? (
            <a href={maintenance} target="_blank" rel="noreferrer" className={style.header_link}>
              {locale("maintenance_table")}
            </a>
          ) : (
            <span className={style.header_link} style={{ color: "#959595", cursor: "default" }}>
              {locale("maintenance_table")}
            </span>
          ))}
        {mileage ? (
          <p className={style.header_km}>
            <FormatUnit value={mileage} unit="kilometer" />
          </p>
        ) : null}
      </div>
      <div className="col-md-5">
        <table
          className={`${style.header_table} ${!least_deposit && !least_installment ? style.single_row_table : ""}`}
        >
          <tbody>
            <tr
              className={`${style.header_price}
                  `}
            >
              {+price === 0 ? (
                <td>
                  {vehicleState === "new" ? (
                    locale("currentlyUnavailableNewVehicle")
                  ) : (
                    <a href={`tel:${phone}`}>{locale("callForPrice")}</a>
                  )}
                </td>
              ) : (
                <>
                  <td>{vehicleState === "new" ? `${locale("price")}:` : ""}</td>
                  <td>
                    {old_price && has_discount && (
                      <span className={style.header_discount}>
                        <FormatPrice value={old_price} />
                      </span>
                    )}
                    <FormatPrice value={price} />
                  </td>
                </>
              )}
            </tr>
            {rent ? (
              <tr>
                <td></td>
                <td style={{ color: "#959595" }}>
                  <FormatPrice value={rent} /> / {locale("month")}
                </td>
              </tr>
            ) : null}
            {least_deposit && (
              <tr>
                <td>{locale("min_deposit")}:</td>
                <td>
                  <FormatPrice value={least_deposit} />
                </td>
              </tr>
            )}
            {least_installment && (
              <tr>
                <td>{locale("min_installment")}: </td>
                <td>
                  <FormatPrice value={least_installment} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {date && (
          <p className={style.header_date}>
            <FormatDate value={date} />
          </p>
        )}
      </div>
    </div>
  );
};

export default VehicleHeader;

export type HeaderType = {
  name: string;
  price: string;
  has_discount?: boolean;
  old_price?: string;
  model?: string;
  date?: string;
  maintenance?: string;
  mileage?: number;
  least_deposit?: string;
  least_installment?: string;
  vehicleState?: "new" | "used" | "imported";
  rent?: number;
  phone?: string;
};

interface ComponentPropsType extends HeaderType {}
